class FeaturedBeveragesCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.featured-beverages__track');
    this.controls = this.querySelector('.featured-beverages__controls');
    this.prevButton = this.querySelector('.featured-beverages__scroll-button[name="previous"]');
    this.nextButton = this.querySelector('.featured-beverages__scroll-button[name="next"]');

    if (!this.track || !this.controls || !this.prevButton || !this.nextButton) return;

    this.onScroll = this.updateControls.bind(this);
    this.onPrevClick = () => this.scrollByStep(-1);
    this.onNextClick = () => this.scrollByStep(1);
    this.onWheel = this.handleWheel.bind(this);

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.prevButton.addEventListener('click', this.onPrevClick);
    this.nextButton.addEventListener('click', this.onNextClick);
    this.track.addEventListener('wheel', this.onWheel, { passive: false });

    this.onResize = () => this.updateControls();
    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(this.track);

    window.addEventListener('resize', this.onResize);
    this.track.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', this.onResize, { once: true });
      }
    });

    this.controls.hidden = false;
    this.controls.classList.remove('featured-beverages__controls--hidden');
    this.updateControls();
  }

  disconnectedCallback() {
    if (!this.track) return;

    this.track.removeEventListener('scroll', this.onScroll);
    this.track.removeEventListener('wheel', this.onWheel);
    this.prevButton?.removeEventListener('click', this.onPrevClick);
    this.nextButton?.removeEventListener('click', this.onNextClick);
    window.removeEventListener('resize', this.onResize);
    this.resizeObserver?.disconnect();
  }

  getScrollStep() {
    const card = this.track.querySelector('.featured-beverages__card');
    if (!card) return this.track.clientWidth * 0.85;

    const gap = Number.parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap) || 0;
    return card.offsetWidth + gap;
  }

  scrollByStep(direction) {
    this.track.scrollBy({
      left: direction * this.getScrollStep(),
      behavior: 'smooth',
    });
  }

  updateControls() {
    this.controls.hidden = false;
    this.controls.classList.remove('featured-beverages__controls--hidden');

    const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth;
    this.prevButton.disabled = this.track.scrollLeft <= 1;
    this.nextButton.disabled = maxScrollLeft <= 1 || this.track.scrollLeft >= maxScrollLeft - 1;
  }

  handleWheel(event) {
    if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

    event.preventDefault();
    window.scrollBy({
      top: event.deltaY,
      left: 0,
      behavior: 'auto',
    });
  }
}

if (!customElements.get('featured-beverages-carousel')) {
  customElements.define('featured-beverages-carousel', FeaturedBeveragesCarousel);
}
